import { render } from "./Beneficios.vue?vue&type=template&id=0b7ca27d&scoped=true"
import script from "./Beneficios.vue?vue&type=script&lang=js"
export * from "./Beneficios.vue?vue&type=script&lang=js"

import "./beneficios.scss?vue&type=style&index=0&id=0b7ca27d&lang=scss&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b7ca27d"]])

export default __exports__